<template>
  <saffron class="app-external-wrapper" :use-meta="true">
    <template #top>
      <floating-widget
        v-if="
          $store.getters['user/profile']?.id &&
          !$store.getters['user/profile']?.isSuperAdmin
        "
        trigger-icon="chat-message"
        trigger-bg-theme="alt"
        trigger-theme="text"
        class="l:visible"
        :show-trigger="true"
        :drawer-props="{ style: { width: '500px' } }">
        <template #default="{ isOpened, floatingWidget }">
          <h3 class="margin-m-bottom">
            {{ translateUcFirst("chat.support.title") }}
          </h3>
          <div
            class="flex-column flex-center flex-middle width-expand padding-l-vertical"
            style="height: 100%">
            <support-chat style="height: calc(100lvh - 140px)"></support-chat>
          </div>

          <!--'264d5ff4-f2c3-4d2c-986c-c6039060f83a'-->
        </template>
      </floating-widget>
      <floating-widget
        v-if="
          $store.getters['user/profile']?.id &&
          $store.getters['user/profile']?.isSuperAdmin
        "
        trigger-icon="chat-message"
        trigger-bg-theme="alt"
        trigger-theme="text"
        class="l:visible"
        :show-trigger="true"
        :drawer-props="{ style: { width: '100%' } }">
        <template #default="{ isOpened, floatingWidget }">
          <div
            class="flex-column flex-center flex-middle width-expand padding-l-vertical"
            style="height: 100%">
            <chat-view style="max-height: calc(100lvh - 240px)"></chat-view>
          </div>

          <!--'264d5ff4-f2c3-4d2c-986c-c6039060f83a'-->
        </template>
      </floating-widget>
      <div
        v-if="isAdmin"
        class="padding border-thin bg-inverse c-bg z-level-top-3"
        style="
          position: fixed;
          bottom: var(--margin-s);
          inset-inline-start: var(--margin-s);
        ">
        <icon-text icon="shield-check" text="justopp.adminModeExplain"></icon-text>
      </div>
    </template>
  </saffron>
</template>

<script>
import SaffronComponent from "@/client/components/Saffron.vue";
import SupportChat from "@/client/components/chat/SupportChat.vue";
import ChatView from "@/client/views/Chat.vue";
import useTracking from "@/client/applications/justopp/extensions/composition/useTracking.js";

export default {
  components: {
    Saffron: SaffronComponent,
    SupportChat,
    ChatView,
  },
  props: {
    layout: {
      type: String,
      default: "default",
    },
    forcedLayout: {
      default: false,
      validator: (value) => typeof value === "string" || value === false,
    },
  },
  setup() {
    const { hitSourceTracking } = useTracking();
    return { hitSourceTracking };
  },
  data() {
    return {};
  },
  computed: {
    isAdmin() {
      return this.$store.getters["user/isAdmin"];
    },
  },
  created() {
    this.hitSourceTracking();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.global-app-wrapper {
  display: flex;
  flex-direction: column;
  flex: 100vh;
  min-height: 100vh;
}
</style>

<style lang="scss"></style>
